<div mat-dialog-title class="mat-title" i18n>New phone number blocks</div>
<form #form="ngForm" novalidate (ngSubmit)="save()">
    <!-- #region Numbers count -->
    <div layout="row" flex>
        <mat-form-field flex layout-margin>
            <mat-label i18n>Numbers count</mat-label>
            <input matInput type="number" [onlyNumber]="true" name="count" [(ngModel)]="count" min="1" max="99" #numbersModel="ngModel" required>
            <mat-error *ngIf="numbersModel.errors?.required"><span i18n>Numbers count</span><span i18n> is required</span></mat-error>
        </mat-form-field>
    </div>
    <!-- #endregion -->

    <div mat-dialog-actions class="pad-top">
        <button type="submit" mat-flat-button color="primary" [disabled]="count <= 0" color="primary" i18n>Save</button>
        <button type="button" mat-button (click)="cancel()" i18n>Cancel</button>
    </div>
</form>